export default __webpack_public_path__ + "static/media/medicines.d9e31ebd.svg";